import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrideVelocity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 91.416,
	height: 34.802,
	viewBox: "0 0 91.416 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_111",
		"data-name": "Group 111",
		transform: "translate(0.5 0.5)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_109",
				"data-name": "Group 109",
				transform: "translate(9.007 1.467)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_248",
						"data-name": "Path 248",
						d: "M235.059,266.058A1.056,1.056,0,0,0,236.114,265v-3.167a1.056,1.056,0,1,0-2.111,0V265A1.056,1.056,0,0,0,235.059,266.058Z",
						transform: "translate(-234.001 -258.733)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_249",
						"data-name": "Path 249",
						d: "M235.059,279.293a1.056,1.056,0,0,0,1.056-1.056v-3.167a1.056,1.056,0,1,0-2.111,0v3.167A1.056,1.056,0,0,0,235.059,279.293Z",
						transform: "translate(-234.001 -264.982)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_250",
						"data-name": "Path 250",
						d: "M307.773,266.058A1.056,1.056,0,0,0,308.828,265v-3.167a1.056,1.056,0,1,0-2.111,0V265A1.056,1.056,0,0,0,307.773,266.058Z",
						transform: "translate(-268.334 -258.733)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_251",
						"data-name": "Path 251",
						d: "M307.773,279.293a1.056,1.056,0,0,0,1.056-1.056v-3.167a1.056,1.056,0,1,0-2.111,0v3.167A1.056,1.056,0,0,0,307.773,279.293Z",
						transform: "translate(-268.334 -264.982)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_252",
						"data-name": "Path 252",
						d: "M244.435,280.589a14.435,14.435,0,0,0-3.88.873c-.466.149-.907.29-1.166.348-.2.045-.451.087-.726.133-1.614.271-4.972.836-4.642,3.652a2.747,2.747,0,0,0,1.04,1.95c1.225.937,3.069.663,4.7.42a12.591,12.591,0,0,1,1.631-.179,4.727,4.727,0,0,1,1.355.272,8.519,8.519,0,0,0,2.6.445c2.264,0,4.64-1.151,4.8-3.352a3.619,3.619,0,0,0-.993-2.784A6.487,6.487,0,0,0,244.435,280.589Zm.909,5.8a6.461,6.461,0,0,1-2-.357,6.573,6.573,0,0,0-1.958-.361,13.812,13.812,0,0,0-1.942.2c-1.093.163-2.589.384-3.1-.008-.05-.038-.183-.14-.227-.519h0c-.08-.681,1.1-1.022,2.9-1.324.318-.053.6-.1.838-.155.352-.079.813-.226,1.348-.4a13.533,13.533,0,0,1,3.236-.772,4.509,4.509,0,0,1,3.17,1.105,1.513,1.513,0,0,1,.433,1.193C247.975,285.859,246.59,286.392,245.344,286.392Z",
						transform: "translate(-233.999 -268.086)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_253",
						"data-name": "Path 253",
						d: "M321.865,282.368a6.487,6.487,0,0,0-4.716-1.779,14.441,14.441,0,0,0-3.88.873c-.466.149-.906.29-1.166.348-.2.045-.45.087-.726.133-1.614.271-4.972.836-4.642,3.652a2.749,2.749,0,0,0,1.04,1.95c1.225.937,3.07.663,4.7.42a12.6,12.6,0,0,1,1.63-.179,4.731,4.731,0,0,1,1.355.272,8.519,8.519,0,0,0,2.6.445c2.264,0,4.64-1.151,4.8-3.352A3.617,3.617,0,0,0,321.865,282.368Zm-3.807,4.024a6.464,6.464,0,0,1-2-.357,6.574,6.574,0,0,0-1.958-.361,13.813,13.813,0,0,0-1.941.2c-1.093.163-2.589.384-3.1-.008-.05-.038-.183-.14-.227-.519h0c-.08-.681,1.1-1.022,2.9-1.324.318-.053.6-.1.837-.155.352-.079.813-.226,1.349-.4a13.532,13.532,0,0,1,3.236-.772,4.509,4.509,0,0,1,3.17,1.105,1.514,1.514,0,0,1,.433,1.193C320.689,285.859,319.3,286.392,318.058,286.392Z",
						transform: "translate(-268.332 -268.086)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_254",
						"data-name": "Path 254",
						d: "M281.444,300.386a8.53,8.53,0,0,0-2.6.445,4.731,4.731,0,0,1-1.355.272,12.6,12.6,0,0,1-1.631-.178c-1.627-.242-3.471-.517-4.7.42a2.749,2.749,0,0,0-1.04,1.95h0c-.33,2.816,3.028,3.381,4.642,3.652.276.046.524.088.726.133.26.058.7.2,1.167.348a14.427,14.427,0,0,0,3.88.873,6.486,6.486,0,0,0,4.715-1.779,3.613,3.613,0,0,0,.993-2.784C286.083,301.538,283.708,300.386,281.444,300.386Zm2.261,4.7a4.511,4.511,0,0,1-3.17,1.106,13.556,13.556,0,0,1-3.236-.772c-.535-.172-1-.319-1.349-.4-.233-.052-.519-.1-.838-.154-1.8-.3-2.974-.643-2.895-1.324h0c.044-.379.177-.481.227-.519a1.821,1.821,0,0,1,1.042-.22,15.08,15.08,0,0,1,2.06.212,13.831,13.831,0,0,0,1.942.2,6.558,6.558,0,0,0,1.958-.361,6.476,6.476,0,0,1,2-.357c1.247,0,2.631.533,2.694,1.394A1.513,1.513,0,0,1,283.7,305.084Z",
						transform: "translate(-251.044 -277.433)",
						fill: "#101820",
						opacity: .3
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_255",
						"data-name": "Path 255",
						d: "M274.178,261.17c.009-.021.013-.043.021-.065a1.075,1.075,0,0,0,.039-.132c.006-.032.006-.065.01-.1s.011-.07.011-.106-.007-.066-.01-.1a1.027,1.027,0,0,0-.011-.106,1,1,0,0,0-.037-.124c-.008-.024-.013-.049-.023-.073a1.028,1.028,0,0,0-.067-.126c-.011-.018-.018-.039-.031-.057a1.054,1.054,0,0,0-.134-.164l-2.809-2.81a1.056,1.056,0,0,0-1.493,1.493l1.009,1.01H242.2l1.01-1.01a1.056,1.056,0,1,0-1.493-1.493l-2.811,2.811a1.056,1.056,0,0,0,0,1.493h0l2.809,2.81a1.056,1.056,0,1,0,1.493-1.493l-1.009-1.009h28.45l-1.008,1.009a1.055,1.055,0,1,0,1.493,1.493l2.806-2.806a1.027,1.027,0,0,0,.138-.167c.009-.014.016-.03.025-.045A1.029,1.029,0,0,0,274.178,261.17Z",
						transform: "translate(-236.171 -256.901)",
						fill: "#101820"
					})
				]
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_29",
				"data-name": "Rectangle 29",
				width: 72.551,
				height: 33.802,
				fill: "none",
				stroke: "#040505",
				strokeWidth: 1,
				opacity: 0
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_110",
				"data-name": "Group 110",
				transform: "translate(70.457 5.281)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_256",
					"data-name": "Path 256",
					d: "M365.639,268.109v-1.756a2.228,2.228,0,0,0-2.225-2.226h-2.883a2.228,2.228,0,0,0-2.225,2.226V268.1a8.921,8.921,0,0,0-1.363.762,1.056,1.056,0,0,0,1.194,1.742,6.8,6.8,0,1,1-2.866,6.681l1.08,1.08a1.056,1.056,0,1,0,1.493-1.493l-2.811-2.811a1.055,1.055,0,0,0-1.493,0l-2.811,2.811a1.056,1.056,0,1,0,1.493,1.493l.938-.938a8.9,8.9,0,1,0,12.48-9.321Zm-5.222-.658v-1.1a.115.115,0,0,1,.114-.115h2.883a.115.115,0,0,1,.114.115v1.1a8.544,8.544,0,0,0-3.111,0Z",
					transform: "translate(-350.419 -264.127)",
					fill: "#101820"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_257",
					"data-name": "Path 257",
					d: "M371.364,276.11a1.055,1.055,0,0,0-1.056,1.056v4.708a1.055,1.055,0,0,0,.309.746l2.534,2.535a1.056,1.056,0,1,0,1.493-1.493l-2.225-2.225v-4.271A1.056,1.056,0,0,0,371.364,276.11Z",
					transform: "translate(-359.81 -269.785)",
					fill: "#101820"
				})]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgStrideVelocity);
export { ForwardRef as ReactComponent };
